// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    LoadRealTimePricing,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";

export const LoadRealTimeInventory: typeof LoadRealTimePricing = props => {
    const { productInfo, selectedProductId: productId } = props;
    if (!productInfo || !productId) {
        return;
    }

    props.dispatch(
        loadRealTimeInventory({
            productIds: [productId],
            onComplete: realTimeInventoryProps => {
                const realTimeInventory = realTimeInventoryProps?.apiResult;
                if (realTimeInventoryProps?.error) {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimeInventory",
                        productId,
                    });
                } else if (realTimeInventory) {
                    props.dispatch({
                        type: "Pages/ProductDetails/CompleteLoadRealTimeInventory",
                        realTimeInventory,
                    });
                }
            },
        }),
    );
};

// XNG-Changes: add LoadRealTimePricing and LoadRealTimeInventory to chain array (variants are excluded from DisplayProduct)
addToChainAfter(chain, SetProductInfo, LoadRealTimePricing);
addToChainAfter(chain, LoadRealTimePricing, LoadRealTimeInventory);
